import cn from 'classnames'
import { forwardRef } from 'react'
import TextareaAutosize, { TextareaAutosizeProps } from 'react-textarea-autosize'

import styles from './Textarea.module.scss'

export interface TextareaProps extends TextareaAutosizeProps {
  className?: string
  innerClassName?: string
  descriptor?: string
  resizable?: boolean
  error?: string
  variant?: 'plain' | 'default' | 'borderless'
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>((props, ref) => {
  const {
    name,
    placeholder,
    className,
    innerClassName,
    resizable,
    descriptor,
    error = null,
    disabled,
    variant = 'default',
    ...rest
  } = props

  return (
    <div className={cn(styles.root, className)} data-descriptor={descriptor}>
      <TextareaAutosize
        name={name}
        ref={ref}
        className={cn(
          styles.textarea,
          innerClassName,
          styles[variant],
          resizable && styles.resizable,
          disabled && styles.disabled
        )}
        placeholder={placeholder}
        aria-invalid={!!error}
        aria-describedby={`${name}-error`}
        disabled={disabled}
        {...rest}
      />
      {error && (
        <div id={`${name}-error`} className={cn(styles.error, styles[variant])}>
          {error}
        </div>
      )}
    </div>
  )
})

export default Textarea
